<template>
    <div @mouseenter="onMouseEnter" @mouseleave="onMouseLeave" style="height: 80px; position: fixed; top: 0; left: 0; right: 0; z-index: 100;">
      <NavBar :selectedItem="selectedItem" @scroll-to="scrollTo" v-if="showNavBar" @update-selected="updateSelectedItem"/>
    </div>
    <Home ref="Home"/>
    <!--<Video ref="Video" :videoSrc="require('@/assets/le-times.mp4')"/>-->
    <AboutUs ref="AboutUs"/>
    <OurBusiness ref="OurBusiness" @navigate="handleNavigation"/>
    <ContactUs ref="ContactUs"/>
</template>
  
<script>
  import NavBar from './NavBar.vue'
  import Home from './Home.vue'
  //import Video from './Video.vue'
  import AboutUs from './AboutUs.vue'
  import OurBusiness from './OurBusiness.vue'
  import ContactUs from './ContactUs.vue'
  
  export default {
    name: 'HomePage',
    components: {
      NavBar,
      Home,
    //  Video,
      AboutUs,
      OurBusiness,
      ContactUs,
    },
    data() {
      return {
        showNavBar: true,
        selectedItem: 'Home',

      };
    },
    mounted() {
        //获取router中传入的参数参数来设置选中Item
        if(this.$route.params.id){
            this.updateSelectedItem(this.$route.params.id)
        }
        //this.sectionsLoaded.Home = true;
        //this.initObserver();


    },
    watch: {
        //监听选中item变化来设置屏幕滚动
        selectedItem(newItem,oldItem){
            this.scrollTo(newItem)
            console.log("scroll from:",oldItem,"to:",newItem)
        },
    },
    methods: {
        //鼠标移入
        onMouseEnter() {
            this.showNavBar = true;
        },
        //鼠标移出
        onMouseLeave() {
            this.showNavBar = true;
        },
        //滚动至refName组件
        scrollTo(refName) {
            const component = this.$refs[refName];
            if (component && component.$el) {
            component.$el.scrollIntoView({ behavior: 'smooth' });
            }
        },
        // 根据id进行页面路由跳转
        handleNavigation(id) {
            this.$router.push({ name: id });
            console.log("Handling navigation to:", id);
        },
        // 更新选中项
        updateSelectedItem(newItem) {
            this.selectedItem = newItem;
            console.log("New selected item is:",this.selectedItem)
        },
        // initObserver() {
        //   const options = {
        //     root: null,
        //     rootMargin: '0px 0px -20%', // 当元素距离视口底部 20% 时触发
        //     threshold: 0.1,             // 元素只需有 10% 可见即可触发
        //   };

        //   this.observer = new IntersectionObserver(this.handleIntersect, options);

        //   Object.keys(this.$refs).forEach((ref) => {
        //     const componentRef = this.$refs[ref];
        //     const targetElement = componentRef?.$el || componentRef;
        //     if (targetElement) {
        //       this.observer.observe(targetElement);
        //     }
        //   });
        // },

        // handleIntersect(entries) {
        //   entries.forEach((entry) => {
        //     const section = entry.target.dataset.section;

        //     if (entry.isIntersecting) {
        //       // 添加 "visible" 类，并记录已加载的组件
        //       entry.target.classList.add('visible');
        //       this.sectionsLoaded[section] = true;
        //       this.loadedSections[section] = true;
        //     } else if (!this.loadedSections[section]) {
        //       // 若组件未加载过且移出视口，隐藏组件
        //       entry.target.classList.remove('visible');
        //     }
        //   });
        // }
    },

  }
</script>
  
<style>
/* .screen {
  height: 100vh;
  opacity: 0;
  transition: opacity 0.8s ease, transform 0.8s ease;
  transform: translateY(50px); /* 初始状态从下方进入 */
/* 
.visible {
  opacity: 1;
  transform: translateY(0); /* 进入视口时回到正常位置 */


* {
  margin: 0;
  padding: 0;
  box-sizing: border-box; /* 确保包括padding和border在内的总宽度和高度 */
  overflow-x:hidden;
  scroll-behavior: smooth;
}

#app {
  font-family: Futura, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 0px;
}

</style>
  